import ITable from "../../interfaces/ITable";

const telaTabelaCabecalho = () : ITable[]=> {


return [
    { label: "SE", accessor: "seOrigem", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Unidade", accessor: "unidadeOrigem", sortable: true, className: "text-left", classNameData: "text-left" },
    { label: "Criado", accessor: "dtHrCriacao", sortable: true, className: "text-center" , classNameData: "text-center"},
    { label: "Usuário (Criou)", accessor: "nomeUsuarioOrigem", sortable: true, className: "text-left", classNameData: "text-left" },
    { label: "Usuário (Baixou)", accessor: "nomeUsuarioDestino", sortable: true, className: "text-left", classNameData: "text-left" },
    { label: "Baixado", accessor: "dtHrDownload", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Documento", accessor: "nomeDocumento", sortable: true, className: "text-center", classNameData: "text-center" }
];

};


export default telaTabelaCabecalho;
